import React from 'react';
import { Card, Row, Col, Form, Input, InputNumber, Select, Checkbox, Button, message, Modal,
	Table, Typography, Tooltip, Empty, Alert, Tabs, Tag,
} from 'antd';
import { GoldOutlined, RedoOutlined, SettingOutlined, ClockCircleOutlined,
	CheckCircleOutlined, CloseCircleOutlined, ReloadOutlined,
} from '@ant-design/icons';
import { connect } from 'react-redux';
import { initHandler, ajaxViewHandler, ajaxHandler, setConfig } from '../../store/actions';
import { Helmet } from 'react-helmet';
import Config from '../../Config';
import ErrorAlertModal from '../../components/ErrorAlertModal';

const { Text } = Typography;
const { TextArea } = Input;
const { TabPane } = Tabs;

// Dipindah dari tab "Migrasi Legacy" di halaman Gudang Notice (Master) ke
// menu tersendiri di bawah Pengaturan - lihat memori proyek
// changes_jabatan_bebas_batas_perangkat.md / diskusi migrasi-legacy-upt-sendiri
// utk alasan pemisahan izin (dapat_migrasi_legacy_notice = bebas semua UPT,
// dapat_migrasi_legacy_notice_upt_sendiri = HANYA UPT sendiri).
const configClass = {
	title: 'Migrasi Legacy Notice',
	apiUrl: {
		legacyPending: 'gudangnotice/api/box/legacy-pending/',
		migrasiLegacy: 'gudangnotice/api/box/migrasi-legacy/',
		permintaan: 'gudangnotice/api/permintaan-migrasi-legacy/',
		kabupaten: 'master/api/kabupaten/',
		upt: 'pegawai/api/upt/',
	},
	breadCrumb: [<span><SettingOutlined /> Pengaturan</span>, 'Migrasi Legacy Notice'],
};

const PERMINTAAN_STATUS = {
	pending: { color: '#fffbe6', border: '#ffe58f', text: '#ad6800', label: 'Menunggu Persetujuan', icon: <ClockCircleOutlined /> },
	disetujui: { color: '#f6ffed', border: '#b7eb8f', text: '#389e0d', label: 'Disetujui', icon: <CheckCircleOutlined /> },
	ditolak: { color: '#fff1f0', border: '#ffa39e', text: '#cf1322', label: 'Ditolak', icon: <CloseCircleOutlined /> },
};

// Status per baris di tab "Migrasi" (be/gudangnotice/views.py legacy_pending())
// - beda dgn PERMINTAAN_STATUS di atas (itu status PermintaanMigrasiLegacy di
// tab Riwayat). 'belum' sengaja TIDAK ada di sini - kalau belum, kolom Aksi
// tampilkan tombol "Migrasi", bukan Tag.
const MIGRASI_STATUS = {
	pending: { color: '#fffbe6', border: '#ffe58f', text: '#ad6800', label: 'Menunggu Persetujuan', icon: <ClockCircleOutlined /> },
	selesai: { color: '#f6ffed', border: '#b7eb8f', text: '#389e0d', label: 'Sudah Migrasi', icon: <CheckCircleOutlined /> },
};

const StatusTag = ({ value, map }) => {
	const src = map || PERMINTAAN_STATUS;
	const s = src[value] || { color: '#f5f5f5', border: '#d9d9d9', text: '#666', label: value };
	return (
		<Tag icon={s.icon} style={{ borderRadius: 20, fontWeight: 600, fontSize: 12, background: s.color, borderColor: s.border, color: s.text }}>
			{s.label}
		</Tag>
	);
};

const STATUS_MIGRASI_OPTIONS = [
	{ value: 'belum', label: 'Belum Migrasi' },
	{ value: 'pending', label: 'Menunggu Persetujuan' },
	{ value: 'selesai', label: 'Sudah Migrasi' },
];

const config = new Config();

class DataMigrasiLegacyNotice extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			isMobile: window.innerWidth <= 768,
			activeTab: 'migrasi',

			loadingLegacyPending: false, listLegacyPending: [],
			// Pagination dikontrol via state (current+pageSize), BUKAN literal
			// inline - kalau cuma pageSize literal tanpa onChange, AntD Table
			// nimpa balik pilihan size-changer user ke nilai literal ini di
			// SETIAP re-render (gotcha AntD v4) - komponen ini sering re-render
			// krn filter auto-refresh, jadi kelihatan jelas "tidak berfungsi".
			legacyPendingCurrent: 1, legacyPendingPageSize: 10,
			modalMigrasi: false, loadingMigrasi: false, selectedLegacy: null,
			migrasiKode: '', migrasiAwal: undefined, migrasiAkhir: undefined,

			// Filter tab "Migrasi" - HANYA relevan utk full_access (lihat semua
			// UPT); own_access cuma lihat UPT sendiri (maks 1 baris), filter
			// tidak dirender sama sekali. Default status: tampilkan semua.
			listKabupatenFilter: [], loadingKabupatenFilter: false,
			listUptFilter: [], loadingUptFilter: false,
			filterKabupatenId: undefined, filterUptId: undefined,
			filterStatus: ['belum', 'pending', 'selesai'],

			loadingPermintaan: false, listPermintaan: [],
			permintaanPagination: { current: 1, pageSize: 10, total: 0 },
			modalApprovePermintaan: false, modalRejectPermintaan: false,
			selectedPermintaan: null, loadingActionPermintaan: false, catatanApprovalPermintaan: '',

			errTitle: '', errMsg: '',
		};
	}

	UNSAFE_componentWillMount() {
		this.props.initHandler();
	}

	componentDidMount() {
		this._handleResize = () => this.setState({ isMobile: window.innerWidth <= 768 });
		window.addEventListener('resize', this._handleResize);
		if (this.canAkses()) this.fetchLegacyPending();
		if (this.canAkses() || this.canApprove()) this.fetchPermintaan();
		if (this.canFullAccess()) {
			this.fetchKabupatenFilter();
			this.fetchUptFilter();
		}
	}

	componentWillUnmount() {
		window.removeEventListener('resize', this._handleResize);
	}

	// Kapabilitas migrasi (bukan visibility menu - itu digerbangi Route/Sider
	// terpisah lewat akses.pengaturan_migrasi_legacy_notice) - kombinasi 2
	// flag: bebas semua UPT (lama) ATAU UPT sendiri saja (baru).
	canAkses = () => !!(this.props.akses && (
		this.props.akses.gudang_notice_migrasi_legacy || this.props.akses.gudang_notice_migrasi_legacy_upt_sendiri
	));

	// Full access (bebas semua UPT) - beda dgn canAkses() yg gabungan
	// own+full. Filter kabupaten/UPT di tab Migrasi cuma masuk akal utk
	// role ini krn own_access cuma pernah lihat 1 UPT (miliknya sendiri).
	canFullAccess = () => !!(this.props.akses && this.props.akses.gudang_notice_migrasi_legacy);

	// Approver = dapat_kelola_gudang_notice (persis izin approve Permintaan
	// Stok Notice di Gudang Notice) - SENGAJA bukan flag baru, lihat diskusi
	// desain approval migrasi legacy (opsi B: orang kedua yang sudah biasa
	// mengelola gudang notice, bukan submitter sendiri yang cek ulang).
	canApprove = () => !!(this.props.akses && this.props.akses.gudang_notice_kelola);

	// Filter (kabupaten/UPT/status) HANYA dikirim utk full_access - own_access
	// diabaikan backend krn cuma ada 1 UPT yang relevan (lihat legacy_pending()).
	fetchLegacyPending = () => {
		this.setState({ loadingLegacyPending: true });
		const { filterKabupatenId, filterUptId, filterStatus } = this.state;
		let qs = '';
		if (this.canFullAccess()) {
			const params = [];
			if (filterKabupatenId) params.push(`kabupaten_id=${filterKabupatenId}`);
			if (filterUptId) params.push(`upt_id=${filterUptId}`);
			if (filterStatus && filterStatus.length) params.push(`status=${filterStatus.join(',')}`);
			if (params.length) qs = `?${params.join('&')}`;
		}
		this.props.ajaxViewHandler('get', `${configClass.apiUrl.legacyPending}${qs}`)
			.then(() => {
				if (this.props.isSuccess) {
					const data = this.props.responseMsg;
					this.setState({ listLegacyPending: Array.isArray(data) ? data : [] });
				}
				this.setState({ loadingLegacyPending: false });
			}).catch(() => this.setState({ loadingLegacyPending: false }));
	};

	fetchKabupatenFilter = () => {
		this.setState({ loadingKabupatenFilter: true });
		this.props.ajaxViewHandler('get', `${configClass.apiUrl.kabupaten}?limit=200`)
			.then(() => {
				if (this.props.isSuccess) {
					const data = this.props.responseMsg;
					const list = Array.isArray(data) ? data : (data.results || []);
					this.setState({ listKabupatenFilter: list });
				}
				this.setState({ loadingKabupatenFilter: false });
			}).catch(() => this.setState({ loadingKabupatenFilter: false }));
	};

	// Ambil SEMUA UPT sekali (jumlahnya kecil, ~50) - narrow ke kabupaten yang
	// dipilih dilakukan di render (client-side), BUKAN fetch ulang ke server
	// tiap ganti kabupaten. Sesuai keputusan: filter UPT boleh dipakai
	// LANGSUNG tanpa pilih kabupaten dulu (tidak strict cascade).
	fetchUptFilter = () => {
		this.setState({ loadingUptFilter: true });
		this.props.ajaxViewHandler('get', `${configClass.apiUrl.upt}?limit=200`)
			.then(() => {
				if (this.props.isSuccess) {
					const data = this.props.responseMsg;
					const list = Array.isArray(data) ? data : (data.results || []);
					this.setState({ listUptFilter: list });
				}
				this.setState({ loadingUptFilter: false });
			}).catch(() => this.setState({ loadingUptFilter: false }));
	};

	handleResetFilterLegacy = () => {
		this.setState({
			filterKabupatenId: undefined, filterUptId: undefined,
			filterStatus: ['belum', 'pending', 'selesai'],
			legacyPendingCurrent: 1,
		}, () => this.fetchLegacyPending());
	};

	// Ganti kabupaten -> kosongkan UPT terpilih kalau UPT itu bukan anggota
	// kabupaten baru (hindari Select nampilin value yang sudah tidak ada di
	// daftar opsi yang dinarrow) - lalu langsung refresh (auto-apply, tidak
	// perlu tombol "Cari" terpisah lagi). Reset ke halaman 1 tiap ganti
	// filter - hasil filter beda, tetap di halaman lama bisa kelihatan
	// kosong kalau jumlah halamannya jadi lebih sedikit.
	handleFilterKabupatenChange = (kabupatenId) => {
		const { listUptFilter, filterUptId } = this.state;
		const uptMasihValid = filterUptId && listUptFilter.some(
			(u) => u.id === filterUptId && (!kabupatenId || u.kabupaten === kabupatenId)
		);
		this.setState({
			filterKabupatenId: kabupatenId,
			filterUptId: uptMasihValid ? filterUptId : undefined,
			legacyPendingCurrent: 1,
		}, () => this.fetchLegacyPending());
	};

	handleFilterUptChange = (uptId) => {
		this.setState({ filterUptId: uptId, legacyPendingCurrent: 1 }, () => this.fetchLegacyPending());
	};

	handleFilterStatusChange = (statusList) => {
		this.setState({ filterStatus: statusList, legacyPendingCurrent: 1 }, () => this.fetchLegacyPending());
	};

	// Popup error modern (ErrorAlertModal) pengganti message.error - pesan
	// dari backend bisa cukup panjang (nama UPT, penjelasan multi-kalimat).
	_showError = (title, fallback) => {
		const msg = this.props.responseMsg;
		const errMsg = (typeof msg === 'string' ? msg : (msg && msg.error)) || fallback;
		this.setState({ errTitle: title, errMsg });
	};

	openMigrasi = (row) => {
		this.setState({
			modalMigrasi: true,
			selectedLegacy: row,
			migrasiKode: '',
			migrasiAwal: row.saran_nomor_awal,
			migrasiAkhir: row.saran_nomor_akhir,
		});
	};

	handleMigrasi = () => {
		const { selectedLegacy, migrasiKode, migrasiAwal, migrasiAkhir } = this.state;
		if (!migrasiKode || !migrasiKode.trim()) {
			message.warning({ content: 'Kode notice baru wajib diisi.', duration: 2, key: 'toast' });
			return;
		}
		if (!migrasiAwal || !migrasiAkhir || Number(migrasiAkhir) < Number(migrasiAwal)) {
			message.warning({ content: 'Rentang nomor tidak valid.', duration: 2, key: 'toast' });
			return;
		}
		this.setState({ loadingMigrasi: true });
		this.props.ajaxHandler('post', configClass.apiUrl.migrasiLegacy, {
			upt_id: selectedLegacy.upt_id,
			kode_notice: migrasiKode.trim(),
			nomor_awal: migrasiAwal,
			nomor_akhir: migrasiAkhir,
		}, false, true)
			.then(() => {
				if (this.props.isSuccess) {
					message.success({
						content: `Pengajuan migrasi UPT ${selectedLegacy.upt_nama} terkirim, menunggu persetujuan dari Kantor Induk sebelum box benar-benar aktif.`,
						duration: 3, key: 'toast',
					});
					this.setState({ modalMigrasi: false, selectedLegacy: null });
					this.fetchPermintaan();
					this.fetchLegacyPending();
				} else {
					this._showError('Gagal Mengajukan Migrasi', 'Gagal mengajukan migrasi legacy.');
				}
				this.setState({ loadingMigrasi: false });
			}).catch(() => { this._showError('Gagal Mengirim', 'Gagal mengirim, coba lagi.'); this.setState({ loadingMigrasi: false }); });
	};

	fetchPermintaan = (page = 1) => {
		const { permintaanPagination } = this.state;
		const limit = permintaanPagination.pageSize, offset = (page - 1) * limit;
		this.setState({ loadingPermintaan: true });
		this.props.ajaxViewHandler('get', `${configClass.apiUrl.permintaan}?limit=${limit}&offset=${offset}`)
			.then(() => {
				if (this.props.isSuccess) {
					const data = this.props.responseMsg;
					const results = Array.isArray(data) ? data : (data.results || []);
					this.setState({
						listPermintaan: results,
						permintaanPagination: { ...permintaanPagination, current: page, total: data.count || results.length },
					});
				}
				this.setState({ loadingPermintaan: false });
			}).catch(() => this.setState({ loadingPermintaan: false }));
	};

	openApprovePermintaan = (row) => {
		this.setState({ modalApprovePermintaan: true, selectedPermintaan: row, catatanApprovalPermintaan: '' });
	};

	openRejectPermintaan = (row) => {
		this.setState({ modalRejectPermintaan: true, selectedPermintaan: row, catatanApprovalPermintaan: '' });
	};

	// Backend RE-VALIDASI PENUH ulang di titik ini (kondisi bisa berubah
	// sejak diajukan - UPT lain migrasi duluan, transaksi baru masuk) - kalau
	// sudah tidak aman, ditolak dgn pesan jelas & status TETAP pending
	// (lihat PermintaanMigrasiLegacyViewset.approve di be/gudangnotice/views.py).
	handleApprovePermintaan = () => {
		const { selectedPermintaan, catatanApprovalPermintaan } = this.state;
		this.setState({ loadingActionPermintaan: true });
		this.props.ajaxHandler('post', `${configClass.apiUrl.permintaan}${selectedPermintaan.id}/approve/`, {
			catatan_approval: catatanApprovalPermintaan,
		}, false, true)
			.then(() => {
				if (this.props.isSuccess) {
					message.success({ content: `Migrasi legacy UPT ${selectedPermintaan.upt_nama} disetujui - box notice sudah aktif.`, duration: 2, key: 'toast' });
					this.setState({ modalApprovePermintaan: false, selectedPermintaan: null });
					this.fetchPermintaan();
					this.fetchLegacyPending();
				} else {
					this._showError('Gagal Menyetujui', 'Gagal menyetujui pengajuan migrasi legacy.');
				}
				this.setState({ loadingActionPermintaan: false });
			}).catch(() => { this._showError('Gagal Mengirim', 'Gagal mengirim, coba lagi.'); this.setState({ loadingActionPermintaan: false }); });
	};

	handleRejectPermintaan = () => {
		const { selectedPermintaan, catatanApprovalPermintaan } = this.state;
		this.setState({ loadingActionPermintaan: true });
		this.props.ajaxHandler('post', `${configClass.apiUrl.permintaan}${selectedPermintaan.id}/reject/`, {
			catatan_approval: catatanApprovalPermintaan,
		}, false, true)
			.then(() => {
				if (this.props.isSuccess) {
					message.success({ content: 'Pengajuan migrasi legacy ditolak.', duration: 2, key: 'toast' });
					this.setState({ modalRejectPermintaan: false, selectedPermintaan: null });
					this.fetchPermintaan();
				} else {
					this._showError('Gagal Menolak', 'Gagal menolak pengajuan migrasi legacy.');
				}
				this.setState({ loadingActionPermintaan: false });
			}).catch(() => { this._showError('Gagal Mengirim', 'Gagal mengirim, coba lagi.'); this.setState({ loadingActionPermintaan: false }); });
	};

	_permintaanColumns() {
		const canApprove = this.canApprove();
		const cols = [
			{ title: 'UPT', dataIndex: 'upt_nama', key: 'upt_nama' },
			{ title: 'Kode Baru', dataIndex: 'kode_notice', key: 'kode_notice', width: 100, align: 'center',
				render: (v) => <Text style={{ fontFamily: 'monospace', fontWeight: 700 }}>{v}</Text> },
			{ title: 'Rentang Nomor', key: 'rentang', width: 200,
				render: (_, row) => <Text style={{ fontFamily: 'monospace' }}>{String(row.nomor_awal).padStart(7, '0')} – {String(row.nomor_akhir).padStart(7, '0')}</Text> },
			{ title: 'Diajukan Oleh', dataIndex: 'diajukan_oleh_nama', key: 'diajukan_oleh_nama', render: (v) => v || <Text type="secondary">—</Text> },
			{ title: 'Status', dataIndex: 'status', key: 'status', width: 190, align: 'center',
				render: (v) => <StatusTag value={v} /> },
			{ title: 'Diproses Oleh', dataIndex: 'disetujui_oleh_nama', key: 'disetujui_oleh_nama', render: (v) => v || <Text type="secondary">—</Text> },
		];
		if (canApprove) {
			cols.push({
				title: 'Aksi', key: 'aksi', width: 160, fixed: 'right', align: 'center',
				render: (_, row) => row.status === 'pending' ? (
					<div style={{ display: 'flex', gap: 6, justifyContent: 'center' }}>
						<Tooltip title="Setujui - box notice langsung aktif untuk UPT ini">
							<Button size="small" type="primary" style={{ background: '#389e0d', borderColor: '#389e0d' }} onClick={() => this.openApprovePermintaan(row)}>
								Setujui
							</Button>
						</Tooltip>
						<Tooltip title="Tolak">
							<Button size="small" danger onClick={() => this.openRejectPermintaan(row)}>Tolak</Button>
						</Tooltip>
					</div>
				) : <Text type="secondary">—</Text>,
			});
		}
		return cols;
	}

	_legacyPendingColumns() {
		return [
			{ title: 'UPT', dataIndex: 'upt_nama', key: 'upt_nama' },
			{ title: 'Kabupaten', dataIndex: 'kabupaten_nama', key: 'kabupaten_nama' },
			{ title: 'Kode Legacy', dataIndex: 'kode_legacy', key: 'kode_legacy', width: 110, align: 'center',
				render: (v) => <Text style={{ fontFamily: 'monospace', fontWeight: 700 }}>{v}</Text> },
			{ title: 'Nomor Legacy', dataIndex: 'nomor_legacy', key: 'nomor_legacy', width: 130, align: 'center',
				render: (v) => <Text style={{ fontFamily: 'monospace' }}>{String(v).padStart(7, '0')}</Text> },
			{ title: 'Saran Rentang Box', key: 'saran', width: 220,
				render: (_, row) => (
					<Text type="secondary" style={{ fontFamily: 'monospace' }}>
						{String(row.saran_nomor_awal).padStart(7, '0')} – {String(row.saran_nomor_akhir).padStart(7, '0')}
					</Text>
				) },
			{
				title: 'Aksi', key: 'aksi', width: 170, fixed: 'right', align: 'center',
				render: (_, row) => row.status_migrasi === 'belum' ? (
					<Button size="small" type="primary" style={{ background: '#1e4d8a', borderColor: '#1e4d8a' }}
						onClick={() => this.openMigrasi(row)}>
						Migrasi
					</Button>
				) : <StatusTag value={row.status_migrasi} map={MIGRASI_STATUS} />,
			},
		];
	}

	renderModalMigrasi() {
		const { modalMigrasi, loadingMigrasi, selectedLegacy, migrasiKode, migrasiAwal, migrasiAkhir, isMobile } = this.state;
		if (!selectedLegacy) return null;
		return (
			<Modal
				open={modalMigrasi}
				onCancel={() => this.setState({ modalMigrasi: false, selectedLegacy: null })}
				footer={null}
				destroyOnClose
				centered
				width="min(94vw, 520px)"
				bodyStyle={{ padding: 0 }}
				className="migrasi-legacy-modal"
			>
				<div className="migrasi-legacy-modal-header">
					<div className="migrasi-legacy-modal-icon"><GoldOutlined /></div>
					<div>
						<div className="migrasi-legacy-modal-title">Migrasi Legacy ke Gudang Notice</div>
						<div className="migrasi-legacy-modal-subtitle">Daftarkan box pertama untuk UPT {selectedLegacy.upt_nama}</div>
					</div>
				</div>
				<div className="migrasi-legacy-modal-body">
					<Alert
						type="info"
						showIcon
						style={{ marginBottom: 16, borderRadius: 8 }}
						message="Wajib dicocokkan dengan opname fisik"
						description={
							<div style={{ fontSize: 13 }}>
								Kode legacy saat ini: <b style={{ fontFamily: 'monospace' }}>{selectedLegacy.kode_legacy}</b>,
								{' '}nomor terakhir transaksi: <b style={{ fontFamily: 'monospace' }}>{String(selectedLegacy.nomor_legacy).padStart(7, '0')}</b>.
								Rentang box di bawah WAJIB dicocokkan dengan opname fisik box yang sebenarnya - saran ini cuma pembulatan kelipatan 1000, bukan nilai final.
							</div>
						}
					/>
					<Form layout="vertical">
						<Form.Item label="Kode Notice Baru (khusus UPT ini, jangan reuse kode legacy)" required>
							<Input
								size="large"
								placeholder="contoh: KSG1"
								maxLength={50}
								style={{ borderRadius: 8 }}
								value={migrasiKode}
								onChange={(e) => this.setState({ migrasiKode: e.target.value.toUpperCase() })}
							/>
						</Form.Item>
						<Row gutter={8}>
							<Col span={12}>
								<Form.Item label="Nomor Awal Box (sesuai fisik)" required>
									<InputNumber
										min={1}
										size="large"
										style={{ width: '100%', borderRadius: 8 }}
										value={migrasiAwal}
										onChange={(v) => this.setState({ migrasiAwal: v })}
									/>
								</Form.Item>
							</Col>
							<Col span={12}>
								<Form.Item label="Nomor Akhir Box (sesuai fisik)" required style={{ marginBottom: 24 }}>
									<InputNumber
										min={1}
										size="large"
										style={{ width: '100%', borderRadius: 8 }}
										value={migrasiAkhir}
										onChange={(v) => this.setState({ migrasiAkhir: v })}
									/>
								</Form.Item>
							</Col>
						</Row>
					</Form>
					<div style={{ display: 'flex', gap: 10, flexDirection: isMobile ? 'column' : 'row', justifyContent: 'flex-end' }}>
						<Button
							size="large"
							onClick={() => this.setState({ modalMigrasi: false, selectedLegacy: null })}
							style={{ borderRadius: 8, ...(isMobile ? { width: '100%' } : {}) }}
						>
							Batal
						</Button>
						<Button
							type="primary"
							icon={<GoldOutlined />}
							size="large"
							loading={loadingMigrasi}
							onClick={this.handleMigrasi}
							style={{
								borderRadius: 8,
								background: 'linear-gradient(135deg, #0f2847, #1e4d8a)',
								border: 'none',
								fontWeight: 600,
								...(isMobile ? { width: '100%' } : {}),
							}}
						>
							Daftarkan Box
						</Button>
					</div>
				</div>
			</Modal>
		);
	}

	renderModalApprovePermintaan() {
		const { modalApprovePermintaan, loadingActionPermintaan, selectedPermintaan, catatanApprovalPermintaan, isMobile } = this.state;
		if (!selectedPermintaan) return null;
		return (
			<Modal
				open={modalApprovePermintaan}
				onCancel={() => this.setState({ modalApprovePermintaan: false, selectedPermintaan: null })}
				footer={null}
				destroyOnClose
				centered
				width="min(94vw, 480px)"
				bodyStyle={{ padding: 0 }}
				className="migrasi-legacy-modal"
			>
				<div className="migrasi-legacy-modal-header">
					<div className="migrasi-legacy-modal-icon"><CheckCircleOutlined /></div>
					<div>
						<div className="migrasi-legacy-modal-title">Setujui Migrasi Legacy?</div>
						<div className="migrasi-legacy-modal-subtitle">UPT {selectedPermintaan.upt_nama}</div>
					</div>
				</div>
				<div className="migrasi-legacy-modal-body">
					<div style={{ marginBottom: 16, fontSize: 13, color: '#666', background: '#f5f8fc', border: '1px solid #e3ecf7', borderRadius: 8, padding: '10px 12px' }}>
						Kode <b style={{ fontFamily: 'monospace' }}>{selectedPermintaan.kode_notice}</b>, rentang{' '}
						<b style={{ fontFamily: 'monospace' }}>{String(selectedPermintaan.nomor_awal).padStart(7, '0')}–{String(selectedPermintaan.nomor_akhir).padStart(7, '0')}</b>.
						Sistem akan mengecek ulang kemungkinan tumpang tindih sebelum benar-benar mengaktifkan box - kalau kondisi sudah berubah sejak diajukan, persetujuan ini akan otomatis ditolak dengan penjelasan.
					</div>
					<TextArea
						rows={2}
						placeholder="Catatan (opsional)"
						value={catatanApprovalPermintaan}
						style={{ borderRadius: 8, marginBottom: 24 }}
						onChange={(e) => this.setState({ catatanApprovalPermintaan: e.target.value })}
					/>
					<div style={{ display: 'flex', gap: 10, flexDirection: isMobile ? 'column' : 'row', justifyContent: 'flex-end' }}>
						<Button
							size="large"
							onClick={() => this.setState({ modalApprovePermintaan: false, selectedPermintaan: null })}
							style={{ borderRadius: 8, ...(isMobile ? { width: '100%' } : {}) }}
						>
							Batal
						</Button>
						<Button
							type="primary"
							icon={<CheckCircleOutlined />}
							size="large"
							loading={loadingActionPermintaan}
							onClick={this.handleApprovePermintaan}
							style={{ borderRadius: 8, background: 'linear-gradient(135deg, #389e0d, #237804)', border: 'none', fontWeight: 600, ...(isMobile ? { width: '100%' } : {}) }}
						>
							Ya, Setujui
						</Button>
					</div>
				</div>
			</Modal>
		);
	}

	renderModalRejectPermintaan() {
		const { modalRejectPermintaan, loadingActionPermintaan, selectedPermintaan, catatanApprovalPermintaan, isMobile } = this.state;
		if (!selectedPermintaan) return null;
		return (
			<Modal
				open={modalRejectPermintaan}
				onCancel={() => this.setState({ modalRejectPermintaan: false, selectedPermintaan: null })}
				footer={null}
				destroyOnClose
				centered
				width="min(94vw, 460px)"
				bodyStyle={{ padding: 0 }}
				className="migrasi-legacy-modal"
			>
				<div className="migrasi-legacy-modal-header">
					<div className="migrasi-legacy-modal-icon"><CloseCircleOutlined /></div>
					<div>
						<div className="migrasi-legacy-modal-title">Tolak Pengajuan Migrasi Legacy</div>
						<div className="migrasi-legacy-modal-subtitle">UPT {selectedPermintaan.upt_nama}</div>
					</div>
				</div>
				<div className="migrasi-legacy-modal-body">
					<div style={{ marginBottom: 12, fontSize: 13, color: '#666' }}>
						Pengajuan ini akan ditolak dan tidak bisa diproses lagi - tidak ada box yang dibuat. UPT perlu mengajukan ulang dengan data yang sudah dikoreksi.
					</div>
					<TextArea
						rows={3}
						placeholder="Alasan penolakan (opsional)"
						value={catatanApprovalPermintaan}
						style={{ borderRadius: 8, marginBottom: 24 }}
						onChange={(e) => this.setState({ catatanApprovalPermintaan: e.target.value })}
					/>
					<div style={{ display: 'flex', gap: 10, flexDirection: isMobile ? 'column' : 'row', justifyContent: 'flex-end' }}>
						<Button
							size="large"
							onClick={() => this.setState({ modalRejectPermintaan: false, selectedPermintaan: null })}
							style={{ borderRadius: 8, ...(isMobile ? { width: '100%' } : {}) }}
						>
							Batal
						</Button>
						<Button
							danger
							type="primary"
							icon={<CloseCircleOutlined />}
							size="large"
							loading={loadingActionPermintaan}
							onClick={this.handleRejectPermintaan}
							style={{ borderRadius: 8, fontWeight: 600, ...(isMobile ? { width: '100%' } : {}) }}
						>
							Tolak
						</Button>
					</div>
				</div>
			</Modal>
		);
	}

	render() {
		const {
			isMobile, loadingLegacyPending, listLegacyPending, activeTab,
			legacyPendingCurrent, legacyPendingPageSize,
			loadingPermintaan, listPermintaan, permintaanPagination,
			listKabupatenFilter, listUptFilter, filterKabupatenId, filterUptId, filterStatus,
		} = this.state;
		const uptOptionsFilter = filterKabupatenId
			? listUptFilter.filter((u) => u.kabupaten === filterKabupatenId)
			: listUptFilter;

		return (
			<div>
				<Helmet>
					<title>{configClass.title + ' | ' + config.get_site_info().name}</title>
					<style>{`
						.migrasi-legacy-wrap .ant-table-thead > tr > th {
							background: linear-gradient(135deg, #0f284711, #1e4d8a11) !important;
							font-weight: 700; font-size: 13px; color: #0f2847;
							border-bottom: 2px solid #d0dff5;
						}
						.migrasi-legacy-wrap .ant-table-tbody > tr:hover > td { background: #e8f0fb !important; }
						.migrasi-legacy-wrap .ant-table-tbody > tr:nth-child(even) > td { background: #fafafa; }
						.migrasi-legacy-wrap .ant-table-tbody > tr:nth-child(even):hover > td { background: #e8f0fb !important; }

						/* ===== Modal modern (sama pola dgn modal-notice di AdminLayout.jsx) ===== */
						.migrasi-legacy-modal .ant-modal-content {
							border-radius: 16px;
							overflow: hidden;
						}
						.migrasi-legacy-modal-header {
							display: flex;
							align-items: center;
							gap: 14px;
							padding: 20px 24px 16px;
							background: linear-gradient(135deg, #0f2847, #1e4d8a);
						}
						.migrasi-legacy-modal-icon {
							width: 44px; height: 44px;
							border-radius: 12px;
							background: rgba(255,255,255,0.15);
							display: flex; align-items: center; justify-content: center;
							font-size: 20px; color: #fff;
							flex-shrink: 0;
						}
						.migrasi-legacy-modal-title { font-size: 16px; font-weight: 700; color: #fff; line-height: 1.2; }
						.migrasi-legacy-modal-subtitle { font-size: 12px; color: rgba(255,255,255,0.65); margin-top: 2px; }
						.migrasi-legacy-modal-body { padding: 24px; }
						.migrasi-legacy-modal .ant-form-item-label > label { font-weight: 600; color: #374151; }
						@media (max-width: 575px) {
							.migrasi-legacy-modal .ant-modal { margin: 0 !important; max-width: 100% !important; top: 0 !important; padding-bottom: 0 !important; }
							.migrasi-legacy-modal .ant-modal-content { border-radius: 0; min-height: 100vh; }
							.migrasi-legacy-modal-header { padding: 16px 16px 14px; }
							.migrasi-legacy-modal-body { padding: 16px; }
						}
					`}</style>
				</Helmet>

				<Card className="migrasi-legacy-wrap" style={{ borderRadius: 14, boxShadow: '0 4px 20px rgba(0,0,0,0.07)', overflow: 'hidden' }} bodyStyle={{ padding: 0 }}>
					<div style={{
						padding: '16px 20px',
						background: 'linear-gradient(135deg, #0f2847, #1e4d8a)',
						display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 10,
					}}>
						<div style={{ color: '#fff', fontWeight: 700, fontSize: 17 }}>
							<GoldOutlined style={{ marginRight: 8 }} />
							{configClass.title}
						</div>
						<Tooltip title="Refresh data">
							<Button icon={<RedoOutlined />} style={{ borderRadius: 8, background: 'rgba(255,255,255,0.15)', border: 'none', color: '#fff' }}
								onClick={() => { this.fetchLegacyPending(); this.fetchPermintaan(); }}>
								{!isMobile && 'Refresh'}
							</Button>
						</Tooltip>
					</div>
					<div style={{ padding: '8px 20px 0' }}>
						<Tabs activeKey={activeTab} onChange={(k) => this.setState({ activeTab: k })}>
							<TabPane tab="Migrasi Legacy" key="migrasi">
								<Alert
									type="warning"
									showIcon
									style={{ marginBottom: 12 }}
									message="Khusus UPT yang masih pakai counter lama (belum pernah punya box Gudang Notice)"
									description="Pastikan opname fisik box sudah dilakukan sebelum mendaftarkan rentang nomor - rentang yang diinput WAJIB sesuai box fisik yang sebenarnya dipegang UPT, bukan sekadar saran otomatis di bawah ini. Pengajuan TIDAK langsung aktif - wajib disetujui oleh Kantor Induk dulu (lihat tab Riwayat Pengajuan). Kalau Anda hanya punya izin UPT sendiri, hanya UPT Anda sendiri (sesuai UPT yang dipilih setelah login) yang akan muncul di tabel ini."
								/>
								{this.canFullAccess() && (
									<div style={{
										background: '#f8fafc', border: '1px solid #eef2f7', borderRadius: 10,
										padding: '14px 16px', marginBottom: 14,
									}}>
										<div style={{ display: 'flex', flexWrap: 'wrap', gap: '14px 20px' }}>
											<div style={{ flex: '0 1 220px', minWidth: 180 }}>
												<div style={{ fontSize: 12, fontWeight: 600, color: '#374151', marginBottom: 6 }}>Kabupaten</div>
												<Select
													allowClear
													placeholder="Semua kabupaten"
													style={{ width: '100%', borderRadius: 8 }}
													showSearch
													optionFilterProp="children"
													value={filterKabupatenId}
													onChange={this.handleFilterKabupatenChange}
												>
													{listKabupatenFilter.map((k) => (
														<Select.Option key={k.id} value={k.id}>{k.name}</Select.Option>
													))}
												</Select>
											</div>
											<div style={{ flex: '0 1 220px', minWidth: 180 }}>
												<div style={{ fontSize: 12, fontWeight: 600, color: '#374151', marginBottom: 6 }}>UPT</div>
												<Select
													allowClear
													placeholder="Semua UPT"
													style={{ width: '100%', borderRadius: 8 }}
													showSearch
													optionFilterProp="children"
													value={filterUptId}
													onChange={this.handleFilterUptChange}
												>
													{uptOptionsFilter.map((u) => (
														<Select.Option key={u.id} value={u.id}>{u.nama}</Select.Option>
													))}
												</Select>
											</div>
											<div style={{ flex: '1 1 260px', minWidth: 220 }}>
												<div style={{ fontSize: 12, fontWeight: 600, color: '#374151', marginBottom: 6 }}>Status</div>
												<Checkbox.Group
													style={{ display: 'flex', flexWrap: 'wrap', gap: '6px 18px', paddingTop: 6 }}
													value={filterStatus}
													onChange={this.handleFilterStatusChange}
												>
													{STATUS_MIGRASI_OPTIONS.map((o) => (
														<Checkbox key={o.value} value={o.value}>{o.label}</Checkbox>
													))}
												</Checkbox.Group>
											</div>
										</div>
										<div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 14 }}>
											<Button
												icon={<ReloadOutlined />}
												style={{ borderRadius: 8 }}
												onClick={this.handleResetFilterLegacy}
											>
												Reset
											</Button>
										</div>
									</div>
								)}
								<Table
									columns={this._legacyPendingColumns()}
									dataSource={listLegacyPending}
									loading={loadingLegacyPending}
									rowKey="upt_id"
									scroll={{ x: 'max-content' }}
									size="middle"
									locale={{ emptyText: <Empty description="Belum ada data UPT" /> }}
									pagination={{
										current: legacyPendingCurrent, pageSize: legacyPendingPageSize,
										showSizeChanger: true, pageSizeOptions: ['10', '25', '50'],
										onChange: (page, pageSize) => this.setState({ legacyPendingCurrent: page, legacyPendingPageSize: pageSize }),
									}}
								/>
							</TabPane>
							<TabPane tab="Riwayat Pengajuan" key="riwayat">
								{this.canApprove() && (
									<Alert
										type="info"
										showIcon
										style={{ marginBottom: 12 }}
										message="Anda berwenang menyetujui/menolak pengajuan migrasi legacy"
										description="Sistem otomatis mengecek ulang kemungkinan tumpang tindih saat approve - kalau kondisi sudah berubah sejak diajukan (mis. UPT lain migrasi kode yang sama duluan), persetujuan akan ditolak otomatis dengan penjelasan, status tetap menunggu."
									/>
								)}
								<Table
									columns={this._permintaanColumns()}
									dataSource={listPermintaan}
									loading={loadingPermintaan}
									rowKey="id"
									scroll={{ x: 'max-content' }}
									size="middle"
									locale={{ emptyText: <Empty description="Belum ada pengajuan migrasi legacy" /> }}
									pagination={{
										current: permintaanPagination.current, pageSize: permintaanPagination.pageSize, total: permintaanPagination.total,
										showSizeChanger: true, pageSizeOptions: ['10', '25', '50'],
										showTotal: (total, range) => `${range[0]}-${range[1]} dari ${total} data`,
										onChange: (page, pageSize) => this.setState(prev => ({ permintaanPagination: { ...prev.permintaanPagination, pageSize } }), () => this.fetchPermintaan(page)),
									}}
								/>
							</TabPane>
						</Tabs>
					</div>
				</Card>

				{this.renderModalMigrasi()}
				{this.renderModalApprovePermintaan()}
				{this.renderModalRejectPermintaan()}

				<ErrorAlertModal
					visible={this.state.errMsg !== ''}
					title={this.state.errTitle}
					error={this.state.errMsg}
					onClose={() => this.setState({ errMsg: '', errTitle: '' })}
				/>
			</div>
		);
	}
}

const mapStateToProps = function (state) {
	return state.configReducers;
};

export default connect(
	mapStateToProps,
	{ initHandler, setConfig, ajaxViewHandler, ajaxHandler }
)(DataMigrasiLegacyNotice);
